//export const API_URL ="http://18.217.35.75:3043";

//export const API_URL = "http://localhost:5000";      /* Localhost */

//export const FRONTEND_URL = "http://18.217.35.75:3042"; 

//export const API_URL = "https://puzzbe.leboco.com"; 

//export const FRONTEND_URL = "https://puzzfe.leboco.com"

export const API_URL = process.env.REACT_APP_API_URL;

export const FRONTEND_URL = "https://snoword.com";
